module.exports={
    logout  : "Log out",
    my      :'Me',
    scqx    :'Del Permissions',
    qxgl    :'Permission Mgmt',
    qdzxzhm :'Are you sure you want to log off?',
    qtxkh   :'Pls fill in Card No',
    qd      :'Confirm',
    qx      :'Cancel',
    gb      :'Close',
    kh      :'Card No',
    kmewm   :'Door Opening QR Code',
    dl      :'Log in',
    name    :'User name',
    qtxname :'Pls fill in user name',
    pwas    :'Password',
    qtxpwas :'Pls fill in password',
    tj      :'Submit',
    zczh    :'Register account',
    zc      :'Register',
    sjhm    :'Mobile No',
    qtxsjhm :'Pls fill in mobile No',
    yzm     :'SMS code',
    qtxyzm  :'Pls fill in verification code',
    yyzhqqdl:'Account existed, to log in',
    hqyzm   :'Get SMS  code',
    zccg    :'Register success',
    zcsb    :'Register failed',
    fscg    :'Sent success',
    fssb    :'Sent failed',
    yhycz   :'User Existed',
	xzsq	:'Please select a community',

    xgmm    : "Change PW",
    zhmm    :'Reset password',
    qrmm    :'Confirm PW',
    zhyxmm  :"Mailbox for recover PW",
    yxyzm   :'Mailbox  code',
    hqyxyzm :'Get Mailbox code',
    zzmmyx  :'Mailbox for Reset PW',
    lcmmbyc :'Two PWs not match',
    xgcg    :'OK Changed',
    xgsb    :'Change Failed',
    qtxyxyx  :'Invalid mailbox',
    lsmhhq  :'Get again in 60s',
    hqyyyzmcg:'Get mailbox verification code OK',
    zhmmbd  :'Account/PW incorrect',
	qsr8wdkh:'Please enter the 8-digit card number',
	jym:'Check code',
	khcwqcxsr:'Wrong card number, please re-enter',
	syym:'All original codes',
	rmcs:'Popular cities',
	xzgjhdq:'Select a country or region',

    // 国家
    // 手机号国家区
    zgdl:'Chinese Mainland',
    zgxg:'Hong Kong, China',
    zgam:'Macao China',
    zgtw:'Taiwan, China',
    afh:"Afghanistan",
    ade:'Andorra',
    agt:'Argentina',
    ymny:'Armenia',
    alb:'Aruba',
    adl:"Austria",
    asbj:'Azerbaijan',

    bhm:'Bahamas',
    bl:'Bahrain',
    bbds:'Barbados',
	bdlg:"Puerto Rico",
    bels:'Belarus',
    bjst:'Pakistan',
    bls:'Belgium',
    cxx:'Korea',
    cdjny:'Equatorial Guinea',
    dg:'Germany',
    dm:'Denmark',
    jbt:'Djibouti',
    dmnjghg:'Dominican republic',
    els:'Russia',
    egde:'Ecuador',
    aj:'Egypt',
    aseby:'Ethiopia',
    am:'Oman',
    alj:'The United Arab Emirates',

    fg:'France',
    fl:'Finland',
    flb:'Philippines',
    fdg:'Vatican',

    gby:'Gambia',
    ggghg:'Republic of the Congo',
    glby:'Columbia',
	gljy:'Georgia',
    gba:'Cuba',
    hg:'the republic of korea',
    hl:'Netherlands',
    hd:'Haiti',

    jbz:'Cambodia',
    jlbs:'Kiribati',
    jny:'Guinea',
    jbbw:"Zimbabwe",
	jk:"Czech",
    kml:'Cameroon',
    kmqt:'Cayman Islands',
    kny:'Kenya',
    kwt:'Kuwait',
    kldy:'Croatia',
    kte:'Qatar',
    lys:'Laos',
    lby:'Libya',
	lbn:'Lebanon',
    lwd:'Rwanda',
    mg:'U.S.A',
    mlxy:'Malaysia',
    mxg:'Mexico',
    ml:"Mali",
    nf:'South Africa',
    nbe:'Nepal',
    nrly:'Nigeria',
    nw:'Norway',
    plqd:'Palau Islands',
    pty:'Portugal',
    rb:'Japan',
    rd:'Sweden',
    rs:'Switzerland',
    stalb:'Saudi Arabia',
    sd:'Sudan',
    slxy:'Saint Lucia',
    tg:'Thailand',
    tjs:'Tonga',
    teq:'turkey',
    wnrl:'Venezuela',
    wl:'Brunei',
    wkl:'Ukraine',
    xxl:'New Zealand',
    xjb:'Singapore',
    xby:'Spain',
    xl:'Greece',
    xyl:'Hungary',
    xly:'Syria',
    ydl:'Italy',
    yg:'britain',
    ydnxy:'Indonesia',
    yd:'India',
	ydd:'Jordan',
    yn:'Vietnam?',
    ylk:'Iraq',
    zl:'Chile',
    zfghg:'Central African Republic',

    //改版
    qsrdxyzm:'Pls fill in verification code',
    fsyzm:'Send verification code',
    yIDhmmdl:'ID and password login',
    qsrID:'Pls fill in ID',
    qsrmm:'Pls fill in password',
    login:'Log in',
    qsrsjhm:'Pls fill in mobile phone number',
    ysjhmdl:'Mobile number login',
    hqyzmsb:'Failed to get verification code!',
    mhzxhq:'Retrieve in seconds',
    xyhzc:'New user registration',
    yhm:'Name',
    mm:'Password',
    qymc:'Enterprise name',
    yx:'Mailbox',
    qsryxyzm:'Pls enter email code',
    hqyzmcg:'Successfully obtained code!',
    yzmbzq:'Incorrect code',
    zhhmmcw:'Wrong account or password',
    xmm:'New password',
    szsb:'Setting failed',
    szcg:'Set successfully',
    zhhyzmcw:'Account or verification code error',
    jmm:'Old password',

    sjhmycz:'Mobile number already exists',
    yxyzmbzq:'Incorrect mailbox verification code',
    yxhsjhmbcz:'Mailbox or mobile number does not exist',

    szkh:'Digital card number',
    fkyq:'Visitor invitation',
    wdmk:'My door card',
    bdcg:'Binding succeeded',
    bdsb:'Binding failed',
    qdjfx:'Please click to share the QR code generated by the link below',
    yxqks:'Valid from now until',
    nn:'within',
    lj:'Link',
    fx:'Share',
    cdcc:'Error generating code',
    fzcg:'Copy succeeded',
    fzsb:'copy failed',
    sss:'hour',
    fff:'minute',
	xzsj:'Select time',
	qxzyxsj:'Please select a valid time',

    kmewmygq:'The QR code for opening the door has expired',

    fzcgts:'The browser you are using does not support direct sharing. Please send the automatically copied content to the invitees'
}